import { ColorMode } from "@chakra-ui/react";

export function getGridClassName(colorMode: ColorMode) {
  return colorMode === "dark" ? "ag-theme-quartz-dark" : "ag-theme-quartz";
}
